import { render, staticRenderFns } from "./UsersListingLeaveRequest.vue?vue&type=template&id=2e055d6c&scoped=true"
import script from "./UsersListingLeaveRequest.vue?vue&type=script&lang=js"
export * from "./UsersListingLeaveRequest.vue?vue&type=script&lang=js"
import style0 from "./UsersListingLeaveRequest.vue?vue&type=style&index=0&id=2e055d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e055d6c",
  null
  
)

export default component.exports